module.exports = __webpack_public_path__ + "img/@logo_hanhwa_pm@3x.0b1fd613.png";